
      import { sendLogData } from './src/modules/shared/services/send-log-data.ts';

      (() => {
        const root = document.querySelector('#root');
        const loaderId = 'main-loading';
        let contentChangeTimer;

        const createLoader = () => {
          const loader = document.createElement('div');
          loader.id = loaderId;
          loader.style.cssText = `
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            gap: 10px;
            height: 90dvh;
            width: 100%;
            animation: pulse 10s infinite ease-in-out;
          `;

          const loadingImage = document.createElement('img');
          loadingImage.src = '/assets/logo/PowerPlay-logo-sportsbook-casino.svg';
          loader.appendChild(loadingImage);

          return loader;
        };

        const removeLoader = () => {
          const loader = document.getElementById(loaderId);
          if (loader) loader.remove();
        };

        const resetContentChangeTimer = () => {
          clearTimeout(contentChangeTimer);
          contentChangeTimer = setTimeout(() => {
            sendLogData(
              'Loading',
              'Page is loading',
              { loadTime: '45s+' },
              'Content not loaded within 45 seconds',
              'Loader timeout',
            );
          }, 45000);
        };

        const handleContentChange = () => {
          if (root.innerHTML !== '') {
            removeLoader();
            clearTimeout(contentChangeTimer);
          } else {
            resetContentChangeTimer();
          }
        };

        if (root.innerHTML === '') {
          root.appendChild(createLoader());
          resetContentChangeTimer();
        }

        const observer = new MutationObserver(handleContentChange);
        observer.observe(root, { childList: true });
      })();
    